import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.scss';

export default function AddSkuPageBanner({ banner }) {
  const containerStyles = cn('l-content-section', styles.bannerWrapper);
  return banner ? (
    <div className={containerStyles}>
      <p className={styles.skuBanner}>
        <strong>Note: </strong>
        {banner}
      </p>
    </div>
  ) : null;
}

AddSkuPageBanner.propTypes = {
  banner: PropTypes.string,
};

AddSkuPageBanner.defaultProps = {
  banner: null,
};
